;(function(doc, win, add, remove, loaded, load) {
    doc.ready = new Promise(function(resolve) {
        if (doc.readyState === 'complete') {
            resolve();
        } else {
            function onReady() {
                resolve();

                doc[remove](loaded, onReady, true);
                win[remove](load, onReady, true);
            }

            doc[add](loaded, onReady, true);
            win[add](load, onReady, true);
        }
    });
})(document, window, 'addEventListener', 'removeEventListener', 'DOMContentLoaded', 'load');

var carousel = {
    navText: [
        '<span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.00049L5 8.00049L11 14.0005" stroke="#111111"/></svg></span>',
        '<span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 2.00049L11 8.00049L5 14.0005" stroke="#111111"/></svg></span>'
    ],

    // Doing this way ensures the carousel only gets initialised once the section has loaded
    init(event, elem) {
        const e = new CustomEvent(event, {
            detail: elem
        });
        
        document.dispatchEvent(e);
    },

    bindEventListeners() {
        document.addEventListener('image-with-text', function(event) {
            document.ready.then(function() {
                setTimeout(function() {
                    $(event.detail).owlCarousel({
                        items: 1,
                        nav: true,
                        dots: true,
                        autoplay: true,
                        autoplayHoverPause: true,
                        loop: true,
                        navText: carousel.navText
                    });
                }, 1000);
            });
        });

        document.addEventListener('image-carousel', function(event) {
            document.ready.then(function() {
                setTimeout(function() {
                    $(event.detail).owlCarousel({
                        nav: true,
                        dots: false,
                        autoplay: true,
                        autoplayHoverPause: true,
                        loop: true,
                        navText: carousel.navText,
                        responsive:{
                            0: {
                                items: 1
                            },
                            600: {
                                items: 2
                            },
                            1000: {
                                items: 4
                            }
                        }
                    });
                }, 1000);
            });
        });

        document.addEventListener('testimonials-carousel', function(event) {
            document.ready.then(function() {
                setTimeout(function() {
                    $(event.detail).owlCarousel({
                        items: 1,
                        nav: true,
                        dots: true,
                        autoplay: true,
                        autoplayHoverPause: true,
                        loop: true,
                        navText: carousel.navText,
                        onInitialized: setContent,
                        onChange: setContent
                    });

                    function setContent(e) {
                        var target_index = 0;
                        
                        if (e.type == 'change') {
                            target_index = e.property.value;
                        }

                        if ($.isNumeric(target_index)) {
                            var content = $(e.target).find('.owl-item').eq(target_index).find('.testimonials-carousel-item-content').html();
                        }

                        $('.testimonial-content-target').html(content);
                    }
                }, 1000);
            });
        });
    }
}

carousel.bindEventListeners();